if (!customElements.get('option-modal')) {
  customElements.define(
    'option-modal',
    class OptionModal extends ModalDialog {
      constructor() {
        super();

        // Selecciona el elemento específico usando el selector proporcionado
        this.triggerElement = document.querySelector('[id^="ProductAccordion-"] > p');

        // Verifica si el elemento existe antes de intentar agregar el evento
        if (this.triggerElement) {
          this.triggerElement.addEventListener('click', this.handleClick.bind(this));
        } else {
          console.error('Trigger element not found for the given selector.');
        }
      }

      hide() {
        super.hide();
      }

      handleClick() {
        super.show(this.triggerElement);
      }
    }
  );
}
